module.exports = __webpack_public_path__ + "img/vip.5f2101f6.png";